import { render, staticRenderFns } from "./EWUserActivityLimitLogForm.vue?vue&type=template&id=5f839936&"
import script from "./EWUserActivityLimitLogForm.vue?vue&type=script&lang=js&"
export * from "./EWUserActivityLimitLogForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports